/* @flow */
// typecheck: ignore file
import React from 'react';
import Text from 'components/Text.jsx';

import './styles/Statistic.scss';

const sizes = [
  'xxxxxsmall',
  'xxxxsmall',
  'xxxsmall',
  'xxsmall',
  'xsmall',
  'small',
  'medium',
  'large',
  'xlarge',
  'xxlarge',
  'xxxlarge',
  'xxxxlarge',
];

type Props = {
  name: string,
  value: number,
  block?: boolean,
  size?: 'xxxsmall' | 'xxsmall' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge' | 'xxxlarge' | 'xxxxlarge';
  nameColor?: string,
}

function Statistic(props: Props) {
  const valueSize = props.size || 'xlarge';
  const nameSize = sizes[sizes.indexOf(valueSize) - 3];
  const element = props.block ? 'div' : 'span';

  return (
    <span className="Statistic">
      <Text element={element} size={valueSize} className="Statistic-value">
        {props.value}
      </Text>
      <Text element={element} size={nameSize} color={props.nameColor}>
        {props.name}
      </Text>
    </span>
  );
}

export default Statistic;



// WEBPACK FOOTER //
// ./src/admin/components/Statistic.jsx